import { IProductDTO } from '@/dtos';
import {
  getRegistrationValidationCodeAPI,
  validateRegistrationValidationCodeAPI,
  uploadValidationAssetConfirmAPI,
  getProductByVariantIdAPI,
} from '@/services/registration';
import { uploadRegistrationValidationAPI } from '@/services';

export const getRegistrationValidationCode = async (email: string): Promise<boolean> => {
  try {
    const result = await getRegistrationValidationCodeAPI(email);
    return result;
  } catch (error) {
    throw error;
  }
};

export const validateRegistrationValidationCode = async (code: string): Promise<boolean> => {
  try {
    const success = await validateRegistrationValidationCodeAPI(code);
    return success;
  } catch (error) {
    throw error;
  }
};

export const uploadValidationAssetConfirm = async (): Promise<boolean> => {
  try {
    const validation = await uploadValidationAssetConfirmAPI();
    return validation;
  } catch (error) {
    throw error;
  }
};

export const uploadRegistrationValidation = async (
  file: File,
  onProgress: (percentComplete: number) => void,
) => {
  try {
    const response = await uploadRegistrationValidationAPI(file, onProgress);
    return response;
  } catch {
    throw 'error uploading validation asset';
  }
};

export const getProductByVariantId = async (variantId: string): Promise<IProductDTO> => {
  try {
    const product = await getProductByVariantIdAPI(variantId);
    return product;
  } catch {
    throw "Can't find Product";
  }
};
